const DEFAULT_SIZE = 16;
const POINTER_SIZE = 30;
const TEXT_WIDTH = 4;
const TEXT_HEIGHT = 20;
function getCursorSize(type, state, { matchPointerSize, matchTextSize, }) {
    switch (type) {
        case "pointer":
            if (matchPointerSize && state.targetBoundingBox) {
                return state.targetBoundingBox;
            }
            return { width: POINTER_SIZE, height: POINTER_SIZE };
        case "text":
            if (matchTextSize && state.fontSize) {
                return { width: TEXT_WIDTH, height: state.fontSize };
            }
            return { width: TEXT_WIDTH, height: TEXT_HEIGHT };
        default:
            return { width: DEFAULT_SIZE, height: DEFAULT_SIZE };
    }
}

export { getCursorSize };
